import api from './axios';

// Formateurs
export const getFormateurs = () => api.get('/formation/formateurs');

// Programs
export const getFormationPrograms = () => api.get('/formation/programs');
export const createFormationProgram = (data) => api.post('/formation/programs', data);
export const updateFormationProgram = (id, data) => api.put(`/formation/programs/${id}`, data);
export const deleteFormationProgram = (id) => api.delete(`/formation/programs/${id}`);

// Apprenants
export const getApprenants = (params) => api.get('/formation/apprenants', { params });
export const getApprenant = (id) => api.get(`/formation/apprenants/${id}`);
export const createApprenant = (data) => api.post('/formation/apprenants', data);
export const updateApprenant = (id, data) => api.put(`/formation/apprenants/${id}`, data);
export const deleteApprenant = (id) => api.delete(`/formation/apprenants/${id}`);
export const updateApprenantStage = (id, data) => api.patch(`/formation/apprenants/${id}/stage`, data);
export const assignFormateur = (id, data) => api.patch(`/formation/apprenants/${id}/assign`, data);
export const assignCloseur = (id, data) => api.patch(`/formation/apprenants/${id}/assign-closeur`, data);
export const ensureApprenantContact = (id) => api.post(`/formation/apprenants/${id}/ensure-contact`);

// RDVs
export const getFormationRdvs = (params) => api.get('/formation/rdvs', { params });
export const createFormationRdv = (data) => api.post('/formation/rdvs', data);
export const updateFormationRdv = (id, data) => api.put(`/formation/rdvs/${id}`, data);
export const deleteFormationRdv = (id) => api.delete(`/formation/rdvs/${id}`);
export const markRdvPresence = (id, data) => api.patch(`/formation/rdvs/${id}/presence`, data);
export const managerReviewRdv = (id, data) => api.patch(`/formation/rdvs/${id}/manager-review`, data);
export const cancelRdv = (id, data) => api.patch(`/formation/rdvs/${id}/cancel`, data);
export const setRdvClosing = (id, est_closing) => api.patch(`/formation/rdvs/${id}/closing`, { est_closing });

// Dashboard & Alerts
export const getFormationDashboard = () => api.get('/formation/dashboard');
export const getFormationPipeline = () => api.get('/formation/pipeline/summary');
export const getFormationAlerts = () => api.get('/formation/alerts');

// User Events (generic calendar events)
// GET /formation/events répond { data, total } là où GET /formation/rdvs renvoie
// un tableau nu. On normalise ici, une fois : sinon chaque appelant doit déballer
// lui-même, et celui qui oublie n'a pas d'erreur — il affiche silencieusement une
// liste vide (c'était le cas d'AgendaWidget).
export const getUserEvents = (params) =>
  api.get('/formation/events', { params })
    .then(r => ({ ...r, data: Array.isArray(r.data) ? r.data : (r.data?.data ?? []) }));
export const createUserEvent = (data) => api.post('/formation/events', data);
export const updateUserEvent = (id, data) => api.put(`/formation/events/${id}`, data);
export const deleteUserEvent = (id) => api.delete(`/formation/events/${id}`);

export const getTeamStats = (params) => api.get('/formation/team-stats', { params });

// Google Calendar
export const getGoogleAuthUrl = () => api.get('/google/auth');
export const getGoogleStatus = () => api.get('/google/status');
export const disconnectGoogle = () => api.post('/google/disconnect');

export const updateSupervision = (userId, data) => api.patch(`/formation/supervision/${userId}`, data);
export const updateNotesManager = (apprenantId, data) => api.patch(`/formation/apprenants/${apprenantId}/notes-manager`, data);
export const mergeApprenants = (data) => api.post('/formation/apprenants/merge', data);
